import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography } from '@mui/material';
export var CircleBadge = function (_a) {
    var index = _a.index;
    return (_jsx(Box, { sx: {
            display: 'flex',
            backgroundColor: '#666666',
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: '1.25rem',
            width: 'auto',
            height: '1.25rem',
            padding: '0 0.25em',
            borderRadius: index > 99 ? '1.25rem' : '50%',
        }, children: _jsx(Typography, { color: "white", fontSize: "0.75em", fontWeight: "500", textAlign: "center", children: index }) }));
};
